import React, { useContext, useState } from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import GroupReportContext from '../../../../Context/GroupReportContext';
import { initialData } from '../groupReport-pdf/QuadrantInFocus';

const Soul = ({ apiData, pageNumber, reportType }) => {
  // console.log("GroupSoulPreview apiData", apiData);
  // console.log("GroupSoulPreview previewData", previewData);

  const groupReportCtx = useContext(GroupReportContext)
  const [dynamicData, setDynamicData] = useState([...initialData]);

  const questions = [
    {
      id: 1,
      question: "My superpower is to rise above any situation to gain a wise perspective.",
      variableBase: "st1"
    },
    {
      id: 2,
      question: "I evaluate decisions by their ability to fulfill the greater vision.",
      variableBase: "st2"
    },
    {
      id: 3,
      question: "I am most fulfilled when I feel like I am living out my greater purpose.",
      variableBase: "st3"
    },
    {
      id: 4,
      question: "I am motivated by opportunities that develop depth of character.",
      variableBase: "st4"
    },
    {
      id: 5,
      question: "I rely heavily on the meaning of my story when working on a project.",
      variableBase: "st5"
    },
    {
      id: 6,
      question: "I believe our work should connect to a larger purpose.",
      variableBase: "st6"
    },
    {
      id: 7,
      question: "I am always searching for the reasons “why” I am doing something.",
      variableBase: "st7"
    },
    {
      id: 8,
      question: "I struggle to stay engaged when the work has no clear purpose.",
      variableBase: "st8"
    },
    {
      id: 9,
      question: "I am drawn to people who are visionaries.",
      variableBase: "st9"
    },
    {
      id: 10,
      question: "I find satisfaction in sharing meaningful stories that impact people's lives.",
      variableBase: "st10"
    }
  ];

  // Render blue squares based on average score (full/partial)
  const renderRectangle = (avgScore, index) => {
    const full = Math.floor(avgScore);
    const partial = avgScore - full;
    if (index < full) {
      // Full blue square
      return <div style={styles.rectangle}></div>;
    } else if (index === full && partial > 0) {
      // Partial blue square (only blue part, no light background)
      return (
        <div style={{ ...styles.rectangle, position: 'relative', overflow: 'hidden', backgroundColor: 'transparent' }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: `${partial * 100}%`,
            height: '100%',
            backgroundColor: '#00577D',
            borderRadius: '2px',
            zIndex: 2,
          }}></div>
        </div>
      );
    } else {
      return null;
    }
  };

  const styles = {
    container: { paddingTop: '16px' },
    heading: { fontSize: "14px", paddingBottom: "16px", lineHeight: "18px", fontWeight: 700, color: "#426B88", margin: 0, fontFamily: "'Helvetica', sans-serif", letterSpacing: 0 },
    description: { marginBottom: "16px", color: "#000000", marginTop: 0, fontFamily: "'Helvetica', sans-serif", fontWeight: 400, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px' },    tableWrapper: { overflow: "hidden", border: "0.25px solid #0000001A", borderRadius: "10px" },
    tableWrapper: { overflow: "hidden", border: "0.25px solid #0000001A", borderRadius: "10px" },
    table: { width: "100%", borderCollapse: "separate", borderSpacing: "0", lineHeight:"13px",  },
    th: { padding: "0 12px", backgroundColor: "#245775", color: "white", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, lineHeight:"13px", fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px' },
    td: { borderLeft: "0.65px solid #ddd", padding: "5px", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px', color: "#000000" },
    soulColumn: { width: "100%", textAlign: "left", padding: "5.5px 15px", border: "none" },
    rowEven: { backgroundColor: "#FFF" },
    rowOdd: { backgroundColor: "#F1F3F3" },
    rectangleWrapper: { display: "flex", justifyContent: "center", alignItems: "center", height: "26px", width: "25px", margin: "0 auto" },
    rectangle: { width: "16px", height: "16px", backgroundColor: "#00577D", borderRadius: "1.34px" }
  };



  const displayData = dynamicData?.filter((el) => el.quadrant == "SOUL");
  const allVariableSets = [apiData?.variables]

  const quadrantScores = {
    "HEART": 1,
    "SOUL": 2,
    "MIND": 3,
    "STRENGTH": 4
  }
  const allResults = [];
  displayData?.forEach((el, index) => {
    // console.log(el.quadrant, quadrantScores?.[el.quadrant])
    const res = groupReportCtx?.calculateQuestionScore(quadrantScores?.[el.quadrant], allVariableSets, index + 1, "in_focus");
    if (res?.averageScore !== null && quadrantScores?.[el.quadrant] == 2) {
      allResults.push(res);
    }
  })

  // console.log("allResults", allResults)

  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <div style={styles.container}>
        <h1 style={styles.heading}>SOUL IN FOCUS</h1>
        <p style={styles.description}>
          This chart isolates the items related to the Soul based on the participant’s self-rating. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </p>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.th, ...styles.soulColumn }}>Soul</th>
                <th style={{ ...styles.th, ...styles.soulColumn }}>Score</th>
                {[1, 2, 3, 4].map((num) => (
                  <th key={num} style={styles.th}>{num}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {questions.map((item, index) => {
                const avgScore = parseInt(allResults[index]?.averageScore);
                return (
                  <tr key={index} style={(index % 2) === 0 ? styles.rowOdd : styles.rowEven}>
                    <td style={{ ...styles.td, ...styles.soulColumn }}>{item.question}</td>
                    <td style={{ ...styles.td }}>{parseFloat(avgScore) > 0 ? avgScore : "-"}</td>
                    {[0, 1, 2, 3].map((idx) => (
                      <td key={idx} style={styles.td}>
                        <div style={styles.rectangleWrapper}>
                          {renderRectangle(avgScore, idx)}
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <FooterPreview reportType={reportType} pageNumber={pageNumber} />
    </div>
  );
};

export default Soul;
